import { create } from 'zustand';
import { Moment } from 'moment';

import { EBlockedEventType, ESortOrder, EStatusStr } from '@src/emp-3.0/types';
import { createSetState } from '@src/emp-3.0/utils/management';
import { IBlockEventData } from '@src/common/types/empTypes';

interface ISelectBlockEvent extends IBlockEventData {
  id: string;
}

interface IUseBlockEventsManagementStoreProps {
  activeBlockEventKey: string | undefined;
  setActiveBlockEventKey: (activeBlockEventKey: string | undefined) => void;
  selectedList: ISelectBlockEvent[];
  setSelectedList: (selectedList: ISelectBlockEvent[]) => void;
  // search
  searchText: string;
  setSearchText: (searchText: string) => void;
  // sort
  sort: { key: string; order: number };
  setSort: (sort: { key: string; order: number }) => void;
  // filter condition
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
  type: EBlockedEventType;
  setType: (type: EBlockedEventType) => void;
  blockedBy: string;
  setBlockedBy: (blockedBy: string) => void;
  blockedDate: Moment[];
  setBlockedDate: (blockedDate: Moment[]) => void;
  // reset
  resetFilter: () => void;
  resetStore: () => void;
}

export const useBlockEventsManagementStore = create<IUseBlockEventsManagementStoreProps>((set) => ({
  activeBlockEventKey: undefined,
  selectedList: [],
  searchText: '',
  sort: { key: '', order: ESortOrder.NORMAL },

  setActiveBlockEventKey: createSetState(set, 'activeBlockEventKey'),
  setSelectedList: createSetState(set, 'selectedList'),
  setSearchText: createSetState(set, 'searchText'),
  setSort: createSetState(set, 'sort'),

  // filter condition
  showFilter: false,
  type: EBlockedEventType.ALL,
  status: EStatusStr.ALL,
  blockedDate: [],
  blockedBy: 'All',

  setShowFilter: createSetState(set, 'showFilter'),
  setType: createSetState(set, 'type'),
  setStatus: createSetState(set, 'status'),
  setBlockedDate: createSetState(set, 'blockedDate'),
  setBlockedBy: createSetState(set, 'blockedBy'),

  // reset
  resetFilter: () =>
    set(() => ({
      type: EBlockedEventType.ALL,
      status: EStatusStr.ALL,
      blockedDate: [],
      blockedBy: 'All',
    })),

  resetStore: () =>
    set(() => ({
      activeBlockEventKey: undefined,
      selectedList: [],
      searchText: '',
      sort: { key: '', order: ESortOrder.NORMAL },
      showFilter: false,
      type: EBlockedEventType.ALL,
      status: EStatusStr.ALL,
      blockedDate: [],
      blockedBy: 'All',
    })),
}));
